import baseURL from '../common/axios';
import { value } from 'dom7';
class SubTaxService {

    //Create API -> To Create Master
    createdata(form) {
        debugger;
        return baseURL.httpMSInventoryUrl.post("SubTaxMasterMAS/Create", form)
    }
    //Get List API -> To Show Table Values 
    getlistdata() {
        debugger;
        return baseURL.httpMSInventoryUrl.get("SubTaxMasterMAS/List")
    }
    //Update API -> To Update Values in Form
    updatedata(form) {
        return baseURL.httpMSInventoryUrl.post("SubTaxMasterMAS/Update", form)
    }
    //Get API -> To Get Values from Table
    getdata(form) {
        return baseURL.httpMSInventoryUrl.get("SubTaxMasterMAS/Get?id=" + form)
    }
    //Delete -> To Delete Values from Table
    deletedata(doc) {
        return baseURL.httpMSInventoryUrl.delete("SubTaxMasterMAS/Delete?id=" + doc)
    }
    //Active
    active(doc, Status) {
        return baseURL.httpMSInventoryUrl.put("SubTaxMasterMAS/Active?id=" + doc + '&Status=' + Status)
    }
}
export default new SubTaxService()